import styled from "styled-components";

const DocumentContent = styled.div<{ hasSignatures: boolean }>`
  flex: ${({ hasSignatures }) => (hasSignatures ? "3" : "1")};
  padding: 4px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  height: 100%;
  overflow-y: auto;
`;

export default DocumentContent;
